export const getUrl = (path, id = null) => {
    if (!path) return path;
    
    // Replace {id} placeholder
    if (path.includes("{id}")) {
        if (id === null) {
            throw new Error('Id Not Found');
        }
        path = path.replace('{id}', id);
    }
    
    // Replace {zoho_id} placeholder
    if (path.includes("{zoho_id}")) {
        if (id === null) {
            throw new Error('Zoho ID Not Found');
        }
        path = path.replace('{zoho_id}', id);
    }

    return path;
}